import { useState } from 'react';
import { handleTrack } from '../../../../utils/tracker';
import { If } from '../../../Atoms/Conditionals';
import { AdvertType } from '../../../Common/HeroComponent';
import { ContactUsModal } from './ContactUsModal';
import { ContactUsSection } from './ContactUsSection';
import ChatFilingCard from './filiing-text';
import { CorporatePage } from '../../../../types/partner-page-types';

export const AdvertCard = ({
  advertisedProducts,
  webinarUrl,
  pocEmail,
  pocPhone,
  pocName,
  postData,
}: {
  advertisedProducts: AdvertType[];
  webinarUrl: string;
  pocEmail?: string;
  pocPhone?: string;
  pocName?: string;
  postData?: CorporatePage;
}) => {
  const [contactUsModal, setContactUsModal] = useState(false);
  const activeProducts = advertisedProducts.filter(
    (product) => product.isActive !== false
  );

  if (activeProducts.length === 0) {
    return null;
  }
  return (
    <>
      <If condition={!!webinarUrl}>
        <a
          onClick={() =>
            handleTrack({
              label: 'hero_cta_register_webinar',
              obj: null,
            })
          }
          target="__blank"
          href={webinarUrl}
          className="flex items-center gap-0.5 text-s-14 font-bold mb-9 sm:my-6"
        ></a>
      </If>
      <div
        className={`flex sm:flex-col-reverse gap-6 flex-1 md:mt-7 sm:mt-6 cursor-pointer ${
          activeProducts.length === 1 ? 'justify-center' : 'justify-between'
        }`}
      >
        {advertisedProducts.map((item) => (
          <a
            href={item.ctaLink}
            key={item.productName}
            className={`${
              item.cardClasses
            } transition-all duration-300 hover:scale-110 p-6 sm:max-w-full w-full sm:text-left rounded-xl flex flex-col justify-between ${
              activeProducts.length === 1 ? 'max-w-md mx-auto' : ''
            }`}
            style={activeProducts.length === 1 ? { maxWidth: '320px' } : {}}
            onClick={(e) =>
              handleTrack({
                label: `hero-cta_${item.ctaText}`,
                obj: e.target,
              })
            }
          >
            <h4 className="text-s-24 font-bold mb-2 cursor-pointer sm:text-s-20">
              {item.productName}
            </h4>
            <p className="text-base leading-snug font-medium cursor-pointer pb-7 sm:text-s-14">
              {item.productDescription}
            </p>
            <ul>
              {item.bulletPoints.map((point, index) => (
                <li key={index} className="flex align-top cursor-pointer">
                  <img
                    src={item.bulletImg}
                    height={'24px'}
                    width={'24px'}
                    className="h-6 w-6"
                  />
                  <div className="text-base cursor-pointer font-medium sm:text-s-14 text-font-500">
                    {point}
                  </div>
                </li>
              ))}
            </ul>
            <div className="flex justify-center cursor-pointer">
              <div className="font-bold text-white text-base leading-none bg-blue-300 rounded-md py-3 w-11/12 mt-8 text-center sm:text-s-14">
                {item.ctaText}
              </div>
            </div>
          </a>
        ))}

        <ContactUsSection
          setContactUsModal={setContactUsModal}
          className="sm:block hidden"
          pocName={pocName}
          pocPhone={pocPhone}
          pocEmail={pocEmail}
        />
      </div>
      <ContactUsModal
        open={contactUsModal}
        onClose={() => setContactUsModal(false)}
        pocName={pocName}
        pocPhone={pocPhone}
        pocEmail={pocEmail}
      />
      <ChatFilingCard postData={postData} id="chat-text" name={''} />
    </>
  );
};
